import { getExperiment } from './getExperiment';
import { IExperimentResultSchema } from '../../repositories/ab-use/entities/entities/ExperimentResultSchema';

export const isAbExperiment = (experiments: IExperimentResultSchema[], experimentName: string, groupName: string) => {
  const experiment = getExperiment(experiments, experimentName);

  return Boolean(experiment && experiment.groupName === groupName);
};
